<template lang="html">
  <div class="overons_wrap">
    <div class="overons_main_title">
      <h1>Over Ons</h1>
    </div>
    <div class="overons_container">
      <div class="overons_section_1"></div>
      <div class="overons_section_2">
        <h1>Geschiedenis</h1>
        <h2>
          J. van den Wijngaart Schilders - Behangers is een familiebedrijf dat is opgericht in 1920 in Amsterdam.
        </h2>
        <h2>
          Vanuit Amsterdam is het later verhuisd naar Uithoorn, waar het nu al weer zo'n vijftig jaar gevestigd is.
          Traditioneel vakwerk staat nog steeds hoog in het vaandel.
        </h2>
        <!-- <h1>Vakkundigheid</h1>
        <h2>
          Wij zijn een OnderhoudNL Garantiebedrijf en werken volgens de garanties en leveringsvoorwaarden overeengekomen met onze brancheorganisatie OnderhoudNL. Zo bent u gegarandeerd van het beste resultaat. Met permanent klantentevredenheids-onderzoek en periodieke technische inspecties wordt de kwaliteit constant onder controle gehouden.
        </h2> -->
        <h1>Vakkundigheid</h1>
        <h2>
          Wij zijn de derde generatie professionele vakschilders / behangers sinds het ontstaan van het familiebedrijf. Wij zijn gevestigid in Uithoorn en schilderen en behangen in Amsterdam en omstreken. Wij leveren ouderwetse kwaliteit, zoals het vak bedoeld is en hebben oog voor detail. Bij ons zijn de communicatielijnen kort en voeren het werk zelf uit.
        </h2>
        <h1>Partners</h1>
        <h2>
          Wij werken voor particulieren, aannemers, Verenigingen van Eigenaren, bedrijven, scholen en winkels.
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">

.overons_main_title{
  width: 100%;
  height: 100px;
  padding: 25px 0 25px 25px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  display: none;
}

.overons_main_title h1{
  font-family: 'Segoe UI', sans-serif;
  font-size: 25px;
  font-weight: 800;
  line-height: 22px;
  color: #222;
  animation: titleanim 0.8s ease 1;
}

  .overons_wrap{
    position: relative;
    width: 100%;
    min-height: 800px;
  }

  .overons_container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
  }

  .overons_section_1{
    width: 50%;
    min-height: 800px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.0),
      rgba(0, 0, 0, 0.0),
      rgba(0, 0, 0, 0.7)
      ),
      url('../../assets/img/oud.jpg');
    background-position: center;
    background-size: cover;
  }

  .overons_section_2{
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    box-sizing: border-box;
    padding: 50px;
    background: #fff;
  }

  .overons_section_2 h1{
    font-size: 25px;
    line-height: 23px;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 800;
    color: #222;
    margin-bottom: 25px;
  }

  .overons_section_2 h2{
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    color: #888;
    margin-bottom: 25px;
  }

  @media only screen and (max-width : 650px) {

    .overons_main_title{
      display: flex;
    }

    .overons_wrap{
      height: auto;
    }

    .overons_container{
      flex-direction: column;
      height: auto;
    }

    .overons_section_1{
      width: 100%;
      min-height: 500px;
      max-height: 500px;
    }

    .overons_section_2{
      width: 100%;
      padding: 25px;
    }

    .overons_section_2 h1{
      font-size: 25px;
      margin-bottom: 25px;
    }

    .overons_section_2 h2{
      font-size: 14px;
      line-height: 18px;
    }
  }
</style>
